import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70d199d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "alert-message" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = { class: "close-button-outer" }
const _hoisted_4 = { class: "close-button-inner" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "×", -1))
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (_ctx.message)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["alert d-flex", _ctx.alertColor])
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("span", {
                textContent: _toDisplayString(_ctx.message)
              }, null, 8, _hoisted_2)
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickDismiss && _ctx.onClickDismiss(...args)))
                }, _hoisted_6)
              ])
            ])
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}